<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-contact">
          <div class="footer-contact-title">联系方式</div>
          <div class="footer-contact-txt">
            <div class="footer-contact-item">电话: 400-600-0115</div>
<!--            <div class="footer-contact-item">邮箱: contact@company.com</div>-->
            <div class="footer-contact-item">地址: 深圳市福田区福田街道岗厦社区彩田路3069号星河世纪A栋3615A21</div>
          </div>
        </div>
        <div class="footer-links">
          <div class="footer-links-title">网站内容</div>
          <div class="footer-links-txt">
            <div class="footer-links-item">
              <router-link to="/about">关于我们</router-link>
            </div>
            <div class="footer-links-item">
              <router-link to="/news">新闻动态</router-link>
            </div>
            <div class="footer-links-item">
              <router-link to="/recruitment">招聘信息</router-link>
            </div>
            <div class="footer-links-item">
              <router-link to="/contact">联系我们</router-link>
            </div>
          </div>
        </div>
        <div class="contact-info">
          <div class="contact-info-title">数字化解决方案</div>
          <div class="contact-info-txt">
            <div class="contact-info-item" @click="handleSkip(item.productLink)" v-for="item in  productList" :key="item.id">
              {{item.productName}}
            </div>
          </div>
        </div>
      </div>
      <div class="footer-line"></div>
<!--      <div class="copyright">-->
<!--        经营许可证编号：陕B2-20210113 | 陕公网安备:61019002002175-->
<!--      </div>-->
      <div class="copyright">
        版权所有 © 2025 {{ systemInfo.systemName || '深圳汇思益企业管理咨询有限公司' }} 粤ICP备2025512004号
      </div>
    </div>
  </footer>
</template>

<script setup>
import {getProductList} from "@/api/apiProduct";
import {onMounted, ref} from "vue";
import {emitter} from "@/eventBus/eventBus";
const productList=ref([])
const systemInfo = ref({})
const handleSkip=(url)=>{
   window.open(url,'_blank')
}
const queryProductList=async ()=>{
  const {code, data}=await getProductList()
  if (code === 200) {
    productList.value = data?.length>4 ? data.slice(0,4) : data;
  }
}

onMounted(() => {
  queryProductList()
  emitter.on('systemInfo',function (data){
    systemInfo.value=data
  })
})


</script>

<style scoped lang="scss">
.footer {
  background: #F4F8FF;
}

.container {
  padding: 40px 0 26px 0;
  text-align: center;
  width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-right: 20px;
  padding-left: 20px;
  box-sizing: border-box;
}


.footer-links-title, .footer-contact-title,.contact-info-title {
  font-size: 16px;
  color: #242424;
  font-weight: bold;
  text-align: left;
  margin-bottom: 20px;
}

.footer-contact-txt {
  font-size: 14px;
  color: #797979;
  text-align: left;
  width: 260px;
  .footer-contact-item {
    margin-bottom: 16px;
  }
}
.contact-info-txt{
  max-width: 200px;
  font-size: 14px;
  color: #797979;
  text-align: left;
  .contact-info-item {
    width: 100%;
    margin-bottom: 16px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover{
      color: #0048A9;
    }
  }
}

.footer-links-txt {
  font-size: 14px;
  text-align: center;

  .footer-links-item {
    margin-bottom: 16px;
    a {
      color: #797979;
      text-decoration: none;
      margin-bottom: 8px;
      transition: color 0.3s;

      &:hover {
        color: #0048A9;
      }
    }

  }
}
.footer-line{
  height: 1px;
  background: #D8D8D8;
  margin: 24px auto 40px auto;

}
.copyright {
  text-align: center;
  font-size: 14px;
  color: #242424;
  margin-bottom: 14px;
}
</style>
